var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "clearfix" },
          [
            _c(
              "el-form",
              { attrs: { inline: "", size: "small", "label-width": "80px" } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "用户查询：" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "260px" },
                      attrs: {
                        placeholder: "请输入UID或手机号",
                        clearable: "",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleSearch($event)
                        },
                      },
                      model: {
                        value: _vm.keyword,
                        callback: function ($$v) {
                          _vm.keyword = $$v
                        },
                        expression: "keyword",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleSearch },
                      },
                      [_vm._v("查询")]
                    ),
                    _c("el-button", { on: { click: _vm.resetSearch } }, [
                      _vm._v("重置"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "box-card mt14",
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.accountList, border: "", stripe: "" },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "45" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "uid",
                  label: "用户UID",
                  width: "100",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "nickname",
                  label: "昵称",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "phone",
                  label: "手机号",
                  width: "130",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "待释放开心果(企/商)",
                  width: "160",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v("企："),
                          _c("span", { staticClass: "highlight orange" }, [
                            _vm._v(
                              _vm._s(scope.row.happyFruitPendingEnterprise)
                            ),
                          ]),
                        ]),
                        _c("div", [
                          _vm._v("商："),
                          _c("span", { staticClass: "highlight orange" }, [
                            _vm._v(_vm._s(scope.row.happyFruitPendingMerchant)),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "佣金(企/商)", width: "150", align: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v("企："),
                          _c("span", { staticClass: "highlight blue" }, [
                            _vm._v(_vm._s(scope.row.commissionEnterprise)),
                          ]),
                        ]),
                        _c("div", [
                          _vm._v("商："),
                          _c("span", { staticClass: "highlight blue" }, [
                            _vm._v(_vm._s(scope.row.commissionMerchant)),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "余额(企/商)", width: "140", align: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v("企："),
                          _c("span", { staticClass: "highlight green" }, [
                            _vm._v(_vm._s(scope.row.balanceEnterprise)),
                          ]),
                        ]),
                        _c("div", [
                          _vm._v("商："),
                          _c("span", { staticClass: "highlight green" }, [
                            _vm._v(_vm._s(scope.row.balanceMerchant)),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "totalConsumeEnterprise",
                  label: "企业专区消费",
                  width: "130",
                  align: "right",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "totalConsumeMerchant",
                  label: "商家专区消费",
                  width: "130",
                  align: "right",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "directCount",
                  label: "直推人数",
                  width: "100",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "isAgent",
                  label: "是否代理",
                  width: "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: scope.row.isAgent ? "success" : "info",
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.isAgent ? "是" : "否") +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "200",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:kx:account:info"],
                                expression: "['admin:kx:account:info']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.viewDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看详情")]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:kx:account:adjust"],
                                expression: "['admin:kx:account:adjust']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.openAdjustDialog(scope.row)
                              },
                            },
                          },
                          [_vm._v("手动调整资金")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            staticStyle: { "margin-top": "20px", "text-align": "right" },
            attrs: {
              "current-page": _vm.page.page,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.page.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "手动调整资金",
            visible: _vm.adjustDialogVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.adjustDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.adjustForm,
                "label-width": "120px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "调整类型" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.adjustForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.adjustForm, "type", $$v)
                        },
                        expression: "adjustForm.type",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "add" } }, [
                        _vm._v("增加"),
                      ]),
                      _c("el-radio", { attrs: { label: "sub" } }, [
                        _vm._v("扣减"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "资金类型" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.adjustForm.fundType,
                        callback: function ($$v) {
                          _vm.$set(_vm.adjustForm, "fundType", $$v)
                        },
                        expression: "adjustForm.fundType",
                      },
                    },
                    [
                      _c(
                        "el-radio",
                        { attrs: { label: "happyFruitPending" } },
                        [_vm._v("待释放开心果")]
                      ),
                      _c("el-radio", { attrs: { label: "commission" } }, [
                        _vm._v("佣金"),
                      ]),
                      _c("el-radio", { attrs: { label: "balance" } }, [
                        _vm._v("余额"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "专区" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.adjustForm.zone,
                        callback: function ($$v) {
                          _vm.$set(_vm.adjustForm, "zone", $$v)
                        },
                        expression: "adjustForm.zone",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "" } }, [
                        _vm._v("通用"),
                      ]),
                      _c("el-radio", { attrs: { label: "Enterprise" } }, [
                        _vm._v("企业"),
                      ]),
                      _c("el-radio", { attrs: { label: "Merchant" } }, [
                        _vm._v("商家"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "金额" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0.01, precision: 2 },
                    model: {
                      value: _vm.adjustForm.amount,
                      callback: function ($$v) {
                        _vm.$set(_vm.adjustForm, "amount", $$v)
                      },
                      expression: "adjustForm.amount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "请输入调整原因",
                    },
                    model: {
                      value: _vm.adjustForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.adjustForm, "remark", $$v)
                      },
                      expression: "adjustForm.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.adjustDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleAdjust },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "账户详情",
            visible: _vm.detailDialogVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialogVisible = $event
            },
          },
        },
        [
          _vm.currentAccount
            ? _c(
                "div",
                { staticClass: "detail-container" },
                [
                  _c(
                    "el-descriptions",
                    { attrs: { column: 2, border: "" } },
                    [
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "用户UID" } },
                        [_vm._v(_vm._s(_vm.currentAccount.uid))]
                      ),
                      _c("el-descriptions-item", { attrs: { label: "昵称" } }, [
                        _vm._v(_vm._s(_vm.currentAccount.nickname || "-")),
                      ]),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "手机号" } },
                        [_vm._v(_vm._s(_vm.currentAccount.phone || "-"))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "待释放开心果(企)" } },
                        [
                          _c("span", { staticClass: "highlight orange" }, [
                            _vm._v(
                              _vm._s(
                                _vm.currentAccount.happyFruitPendingEnterprise
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "待释放开心果(商)" } },
                        [
                          _c("span", { staticClass: "highlight orange" }, [
                            _vm._v(
                              _vm._s(
                                _vm.currentAccount.happyFruitPendingMerchant
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "佣金(企)" } },
                        [
                          _c("span", { staticClass: "highlight blue" }, [
                            _vm._v(
                              _vm._s(_vm.currentAccount.commissionEnterprise)
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "佣金(商)" } },
                        [
                          _c("span", { staticClass: "highlight blue" }, [
                            _vm._v(
                              _vm._s(_vm.currentAccount.commissionMerchant)
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "余额(企)" } },
                        [
                          _c("span", { staticClass: "highlight green" }, [
                            _vm._v(
                              _vm._s(_vm.currentAccount.balanceEnterprise)
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "余额(商)" } },
                        [
                          _c("span", { staticClass: "highlight green" }, [
                            _vm._v(_vm._s(_vm.currentAccount.balanceMerchant)),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "企业专区消费" } },
                        [
                          _vm._v(
                            _vm._s(_vm.currentAccount.totalConsumeEnterprise)
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "商家专区消费" } },
                        [
                          _vm._v(
                            _vm._s(_vm.currentAccount.totalConsumeMerchant)
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "直推人数" } },
                        [_vm._v(_vm._s(_vm.currentAccount.directCount))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "是否代理" } },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.currentAccount.isAgent
                                  ? "success"
                                  : "info",
                                size: "small",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.currentAccount.isAgent ? "是" : "否"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.detailDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }